import { assetUrl } from "./assetUrl"
import { AcademicLeague } from "../types/battle"

export const LEAGUE_BACKGROUND_IMAGES: Record<AcademicLeague, string> = {
  TITAN:
    "https://backend.daks.by/photo/GUARDIANS/1780027903756_05429268455288949_f609a85395f0f34992efedc8d3d137d8.jpg",
  ATLANT:
    "https://backend.daks.by/photo/GUARDIANS/1780027915603_8163772070455906_78cb9f25532bda83e5b98dc9ceee7e05.jpg",
}

export const LEAGUE_ACCENTS: Record<AcademicLeague, string> = {
  TITAN: "#FACC15",
  ATLANT: "#38BDF8",
}

/** Иконки лиг рядом с подписью (assets/guardians/icons). */
export const LEAGUE_ICONS: Record<AcademicLeague, string> = {
  TITAN: assetUrl("icons/titanLiga.png"),
  ATLANT: assetUrl("icons/atlantLiga.png"),
}

/** Отображаемые названия лиг (API и логика — TITAN / ATLANT) */
export const LEAGUE_DISPLAY_NAMES: Record<AcademicLeague, string> = {
  TITAN: "ТИТАНЫ",
  ATLANT: "АТЛАНТЫ",
}

export function formatLeagueLabel(
  league: AcademicLeague | null | undefined
): string {
  if (!league) return "—"
  return LEAGUE_DISPLAY_NAMES[league] ?? "—"
}

export function resolveLeagueIcon(
  league: AcademicLeague | null | undefined
): string | null {
  if (!league) return null
  return LEAGUE_ICONS[league] ?? null
}

export const ACADEMY_LEAGUES_MODAL = {
  title: "Лиги города",
  intro: [
    "Лига — ваша фракция в битве за город. Баланс сил влияет на бонусы новичкам.",
    "Ежедневные тесты и экзамены одинаковы для всех лиг. За ответы — награды и рост карт.",
  ],
  leagues: [
    {
      league: "TITAN" as AcademicLeague,
      body: "Сила, порядок, защита. Золотые акценты. +5% урона по боссам, +3 energy после скана.",
    },
    {
      league: "ATLANT" as AcademicLeague,
      body: "Мудрость, связь, стратегия. Синие акценты. +5% награда за квиз, чаще чакра из лута.",
    },
  ],
  footer:
    "Лигу нельзя изменить после старта. Меньшинство в городе получает +10% монет и чакры на первую неделю.",
}
